/*
 * Secciones v2 del home (flag home_secciones_v2).
 *
 * Tres cosas, todas opcionales: si este archivo no carga, cada seccion sigue
 * funcionando sin el.
 *
 *  1. Pestañas de "Encuentra tu grado" (patron ARIA tablist). Sin JS los
 *     paneles se ven todos, uno debajo de otro, y la lista de pestañas queda
 *     oculta con [hidden].
 *  2. Botones del cierre por rol: tras abrir el modal de registro, eligen el
 *     rol en su select. El select lo maneja el widget customSelect de
 *     script.min.js, asi que se elige pulsando su opcion, que es lo que el
 *     widget escucha.
 *  3. "Inicia sesión" del cierre: abre el modal en la pestaña de login, aunque
 *     antes se hubiera abierto en la de registro.
 *
 * Va con defer: corre despues de jQuery y de script.min.js, que estan al final
 * del body sin defer.
 */
(function () {
    'use strict';

    /* ---------- 1. pestañas ---------- */

    var lista = document.querySelector('.pths-pestanas');

    if (lista) {
        var pestanas = Array.prototype.slice.call(lista.querySelectorAll('[role="tab"]'));
        var paneles = pestanas.map(function (p) {
            return document.getElementById(p.getAttribute('aria-controls'));
        });

        var activar = function (i, enfocar) {
            pestanas.forEach(function (p, k) {
                var sel = k === i;
                p.setAttribute('aria-selected', sel ? 'true' : 'false');
                if (sel) { p.removeAttribute('tabindex'); } else { p.setAttribute('tabindex', '-1'); }
                if (paneles[k]) { paneles[k].hidden = !sel; }
            });
            if (enfocar) { pestanas[i].focus(); }
        };

        pestanas.forEach(function (p, i) {
            p.addEventListener('click', function () { activar(i, false); });
        });

        // Flechas, Inicio y Fin, como manda el patron: el foco se mueve entre
        // pestañas y Tab salta directo al panel.
        lista.addEventListener('keydown', function (ev) {
            var i = pestanas.indexOf(document.activeElement);
            if (i < 0) { return; }
            var n = pestanas.length;
            var destino = null;

            if (ev.key === 'ArrowRight') { destino = (i + 1) % n; }
            else if (ev.key === 'ArrowLeft') { destino = (i - 1 + n) % n; }
            else if (ev.key === 'Home') { destino = 0; }
            else if (ev.key === 'End') { destino = n - 1; }

            if (destino !== null) {
                ev.preventDefault();
                activar(destino, true);
            }
        });

        // Con pestañas, el titulo de cada panel repite la pestaña: se oculta a
        // la vista pero se deja para lectores de pantalla.
        paneles.forEach(function (panel) {
            var t = panel && panel.querySelector('.pths-panel-titulo');
            if (t) { t.classList.add('pths-sr'); }
        });

        lista.hidden = false;
        activar(0, false);
    }

    /* ---------- 2. rol preelegido ---------- */

    function elegirRol(valor, intentos) {
        // Con las secciones v2 el formulario incrustado ya no se pinta: el
        // unico form.register del home es el del modal.
        var select = document.querySelector('form.register select[name="rol"]');
        if (!select) {
            if (intentos > 0) { window.setTimeout(function () { elegirRol(valor, intentos - 1); }, 120); }
            return;
        }

        var opciones = Array.prototype.slice.call(select.options);
        var indice = -1;
        opciones.forEach(function (o, k) { if (o.value === String(valor)) { indice = k; } });
        if (indice < 0) { return; }

        var envoltura = select.closest('.customSelect');
        var etiquetas = envoltura ? envoltura.querySelectorAll('.customSelect-options label') : [];

        if (etiquetas[indice] && window.jQuery) {
            // El widget actualiza su rotulo, marca la opcion y dispara change.
            window.jQuery(etiquetas[indice]).trigger('click');
        } else {
            select.selectedIndex = indice;
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    document.addEventListener('click', function (ev) {
        var boton = ev.target.closest ? ev.target.closest('[data-registro-rol]') : null;
        if (!boton) { return; }
        var valor = boton.getAttribute('data-registro-rol');
        // Despues de que los manejadores del propio boton abran el modal.
        window.setTimeout(function () { elegirRol(valor, 10); }, 0);
    });

    /* ---------- 4. riel de testimonios ---------- */

    /*
     * Mismo comportamiento que los rieles de cursos (riel.js): scroll nativo,
     * flechas solo si no cabe, y avance automatico de una tarjeta cada 6 s con
     * pausa accesible (WCAG 2.2.2): boton visible, se detiene con el cursor
     * encima, con el foco dentro, al deslizarlo, fuera de la vista y con la
     * pestaña oculta. Con movimiento reducido no arranca.
     */
    var rielT = document.querySelector('[data-pths-riel]');
    var seccionT = rielT && rielT.closest('.pths-testimonios');

    if (rielT && seccionT) {
        var reducidoT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var flechasT = seccionT.querySelectorAll('[data-pths-ir]');
        var pausaT = seccionT.querySelector('[data-pths-pausa]');
        var temporizadorT = null;
        var pausadoT = false, encimaT = false, enfocadoT = false, visibleT = false, tocadoHastaT = 0;

        var pasoT = function () {
            var t = rielT.querySelector('.pths-testimonio');
            var hueco = parseFloat(window.getComputedStyle(rielT).columnGap) || 0;
            return t ? t.getBoundingClientRect().width + hueco : rielT.clientWidth;
        };

        var desbordaT = function () { return rielT.scrollWidth - rielT.clientWidth > 1; };

        var pintarT = function () {
            var maximo = rielT.scrollWidth - rielT.clientWidth;
            var hay = desbordaT();
            for (var i = 0; i < flechasT.length; i++) {
                var adelante = flechasT[i].getAttribute('data-pths-ir') === '1';
                flechasT[i].hidden = !hay;
                flechasT[i].disabled = adelante ? rielT.scrollLeft >= maximo - 1 : rielT.scrollLeft <= 1;
            }
            if (pausaT) {
                pausaT.hidden = !hay || reducidoT;
                pausaT.setAttribute('aria-pressed', pausadoT ? 'true' : 'false');
                pausaT.setAttribute('aria-label', (pausadoT ? 'Reanudar' : 'Pausar') + ' el avance de los testimonios');
                pausaT.classList.toggle('is-pausado', pausadoT);
            }
        };

        var programarT = function () {
            window.clearTimeout(temporizadorT);
            temporizadorT = null;
            pintarT();
            if (reducidoT || pausadoT || encimaT || enfocadoT || !visibleT || document.hidden || !desbordaT()) { return; }
            var resta = tocadoHastaT - Date.now();
            if (resta > 0) { temporizadorT = window.setTimeout(programarT, resta + 50); return; }
            temporizadorT = window.setTimeout(function () {
                var maximo = rielT.scrollWidth - rielT.clientWidth;
                if (rielT.scrollLeft >= maximo - 1) { rielT.scrollTo({ left: 0 }); }
                else { rielT.scrollBy({ left: pasoT() }); }
                programarT();
            }, 5000);
        };

        var tocadoT = function () { tocadoHastaT = Date.now() + 8000; programarT(); };

        for (var f = 0; f < flechasT.length; f++) {
            flechasT[f].addEventListener('click', function () {
                var dir = this.getAttribute('data-pths-ir') === '1' ? 1 : -1;
                rielT.scrollBy({ left: dir * pasoT() });
                tocadoT();
            });
        }

        if (pausaT) {
            pausaT.addEventListener('click', function () { pausadoT = !pausadoT; programarT(); });
        }

        rielT.addEventListener('scroll', pintarT, { passive: true });
        rielT.addEventListener('mouseenter', function () { encimaT = true; programarT(); });
        rielT.addEventListener('mouseleave', function () { encimaT = false; programarT(); });
        // Solo el foco de teclado pausa; el de un clic con mouse no se suelta
        // hasta hacer clic fuera y dejaba el riel detenido.
        rielT.addEventListener('focusin', function (ev) {
            try { enfocadoT = ev.target.matches(':focus-visible'); } catch (e) { enfocadoT = true; }
            programarT();
        });
        rielT.addEventListener('focusout', function (ev) {
            if (!rielT.contains(ev.relatedTarget)) { enfocadoT = false; programarT(); }
        });
        rielT.addEventListener('touchstart', tocadoT, { passive: true });
        rielT.addEventListener('wheel', tocadoT, { passive: true });
        rielT.addEventListener('pointerdown', tocadoT);
        document.addEventListener('visibilitychange', programarT);

        if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (e) { visibleT = e[0].isIntersecting; programarT(); }, { threshold: .4 }).observe(rielT);
        } else {
            visibleT = true;
        }

        if (window.ResizeObserver) { new window.ResizeObserver(pintarT).observe(rielT); }

        programarT();
    }

    /* ---------- 3. iniciar sesion ---------- */

    var iniciar = document.getElementById('pths-iniciar');
    if (iniciar) {
        iniciar.addEventListener('click', function () {
            window.setTimeout(function () {
                var login = document.getElementById('login');
                if (login) { login.click(); }
            }, 0);
        });
    }

    /* ---------- 4. Planea con IA desde el home ---------- */
    // "Continuar" guarda el texto en sessionStorage (nunca en la URL: puede
    // traer datos del grupo) y abre DocencIA/Planea, que lo toma y arranca
    // sola (planea-express.js, "Llegada desde el home"). Los terminos usan la
    // misma clave que Planea, asi que aceptarlos aqui vale alla y al reves.

    var planea = document.getElementById('pths-planea');
    if (planea) {
        var campoP = document.getElementById('pths-planea-texto');
        var botonP = planea.querySelector('button[type="submit"]');
        var terminosP = document.getElementById('pths-planea-terminos');
        var cuentaP = document.getElementById('pths-planea-cuenta');
        var CLAVE_TERMINOS = 'planea-terminos-aceptados';
        var CLAVE_TEXTO = 'planea-desde-home';

        try { if (window.localStorage.getItem(CLAVE_TERMINOS) === '1') { terminosP.checked = true; } } catch (e) {}

        var actualizarP = function () {
            cuentaP.textContent = campoP.value.length;
            botonP.disabled = !(campoP.value.trim().length >= 10 && terminosP.checked);
        };

        campoP.addEventListener('input', actualizarP);
        terminosP.addEventListener('change', function () {
            try { window.localStorage.setItem(CLAVE_TERMINOS, terminosP.checked ? '1' : '0'); } catch (e) {}
            actualizarP();
        });

        planea.addEventListener('submit', function (ev) {
            ev.preventDefault();
            if (botonP.disabled) { return; }
            try {
                window.sessionStorage.setItem(CLAVE_TEXTO, JSON.stringify({ texto: campoP.value.trim(), t: Date.now() }));
            } catch (e) {}
            window.location.href = planea.action;
        });

        actualizarP();

        // Placeholder que se escribe solo: con el campo vacio, sin foco y a la
        // vista, escribe y borra ejemplos. Solo toca el placeholder.
        var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var frasesP = [];
        try { frasesP = JSON.parse(campoP.getAttribute('data-frases') || '[]'); } catch (e) {}

        if (!reducido && frasesP.length) {
            var originalP = campoP.getAttribute('placeholder');
            var CURSOR = '▍';
            var timerP = null, indiceP = 0, letrasP = 0, borrandoP = false, visibleP = false;

            var puedeP = function () {
                return visibleP && !document.hidden && campoP.value === '' && document.activeElement !== campoP;
            };
            var detenerP = function () {
                window.clearTimeout(timerP); timerP = null;
                letrasP = 0; borrandoP = false;
                campoP.setAttribute('placeholder', originalP);
            };
            var pasoP = function () {
                if (!puedeP()) { detenerP(); return; }
                var frase = frasesP[indiceP];
                letrasP += borrandoP ? -1 : 1;
                campoP.setAttribute('placeholder', frase.slice(0, letrasP) + CURSOR);
                if (!borrandoP && letrasP >= frase.length) { borrandoP = true; timerP = window.setTimeout(pasoP, 2600); return; }
                if (borrandoP && letrasP <= 0) {
                    borrandoP = false;
                    indiceP = (indiceP + 1) % frasesP.length;
                    timerP = window.setTimeout(pasoP, 500);
                    return;
                }
                timerP = window.setTimeout(pasoP, borrandoP ? 14 : 38 + Math.random() * 40);
            };
            // Sin espera: en cuanto la seccion entra a la vista empieza a escribir.
            var programarP = function () {
                if (timerP) { detenerP(); }
                if (puedeP()) { pasoP(); }
            };

            campoP.addEventListener('focus', detenerP);
            campoP.addEventListener('input', detenerP);
            campoP.addEventListener('blur', programarP);
            document.addEventListener('visibilitychange', programarP);

            if ('IntersectionObserver' in window) {
                new IntersectionObserver(function (e) { visibleP = e[0].isIntersecting; programarP(); }, { threshold: .3 }).observe(campoP);
            } else {
                visibleP = true;
                programarP();
            }
        }
    }
})();
